import { render, staticRenderFns } from "./VVat.vue?vue&type=template&id=6bc2bbb8&"
import script from "./VVat.vue?vue&type=script&lang=js&"
export * from "./VVat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports